import ConfirmForgotPassword from '../components/ConfirmForgotPassword';
import React from 'react';
import action from '../actions/confirmForgotPassword';

export const context = 'confirmForgotPassword';

export class ConfirmForgotPasswordRoute extends React.PureComponent {
    render() {
        return <ConfirmForgotPassword autoComplete={false} context={context} action={action} />;
    }
}

export default ConfirmForgotPasswordRoute;
